
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { setCookie, getCookie } from "./util/util";
import axios from 'axios';
// const ElementUI = require('element-ui');
import App from './App'
import less from 'less'

Vue.use(ElementUI)
Vue.use(less)

Vue.config.productionTip = false

Vue.directive('title', {
  inserted: function (el) {
    document.title = el.dataset.title
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js